import { type Asset } from 'contentful';

import { useContentfulContentTypeEntry } from '@order/Contentful';

// ─────────────────────────────────────────────────────────────────────────────

export const useCustomizationContent = () => {
  const { data, fetching } =
    useContentfulContentTypeEntry<CustomizationContentFields>({
      contentType: CUSTOMIZATION_CONTENT_TYPE,
    });

  return { fields: data?.fields, fetching };
};

// ─── Constants ───────────────────────────────────────────────────────────────

const CUSTOMIZATION_CONTENT_TYPE = 'productDetailsPage';

// ─── Types ───────────────────────────────────────────────────────────────────

type CustomizationContentFields = {
  dressingDetailsImage: Asset | undefined;
  orderCustomizeConfirmExitMessage: string | undefined;
  orderCustomizeConfirmExitConfirmButtonTitle: string | undefined;
  orderCustomizeConfirmExitCancelButtonTitle: string | undefined;
};
